export default {
    index: 'Índice',
    marker: 'Marcadores',
    dictionary: 'Diccionario',
    question: 'Pregunta',
    storyletter: 'Narrador',
    settings: 'Ajustes',
    notes: 'Mis notas',
    music: 'Música',
    searchInput: 'Buscar Definición...',
    warnDictionary: 'Debe buscar una palabra a la vez.',
    warnMark: 'Para marcar un texto, es necesario que selecciones una frase con mínimo cinco palabras.',
    not_question: 'No hay preguntas en el presente capítulo.',
    finish_book: 'Has llegado al final del libro',
    congrats: '¡Felicidades!',
    finish_book_msg: 'Calificalo y luego presiona el boton para volver al inicio y continuar',
    go_back: 'Volver al Inicio',
    bad: 'Malo',
    regular: 'Regular',
    good: '¡Bueno!',
    very_good: '¡Muy Bueno!',
    excellent: '¡Excelente!',
    magnificent: 'Magnífico',
    start_reading: 'Comenzar la lectura',
    qualification: 'Calificación',
    days_to_finish: 'Dias para terminar',
    go_to_library: 'Ir a la biblioteca',
    go_to_home: 'Valorar e ir al inicio',
    congrats_msg_1: 'Has culminado la lectura',
    finish_msg_1: 'Coméntanos, ¿Te gustó el libro?',
    finish_msg_2: '¿Qué te pareció este libro?',
    send: 'Enviar',
    chapter: 'Capítulo',
    answer: 'Responder',
    try_again: 'Volver a intentar',
    continue: 'Continuar',
    understood: 'Entendido',
    clue: 'Pista',
    buy_wildcard: 'Comprar comodín',
    have: 'Tienes',
    wildcard_50_50: 'Comodín <br> 50/50',
    wildcard_buy_msg:
        'Elimina el 50% de las alternativas y aumenta tus probabilidades de acertar.',
    wildcard_used_msg: 'Has comprado el Comodín 50/50',
    characters: 'Personajes',
    actions: 'Acciones',
    vocabulary: 'Vocabulario',
    places: 'Lugares',
    highlight_modal_msg: 'Selecciona la categoría en la que deseas guardar tu marcador:',
    warnMarkSelectType: 'Debes seleccionar un tipo de marcador para continuar',
    highlight_saved: 'Marcador Guardado',
    located_in: 'Ubicado en',
    page: 'página',
    of: 'de',
    music_2: 'Música ambiental',
    music_msg_1: 'Puedes activar y desactivar la música ambiental si lo deseas.',
    listen_background_music: 'Escuchar música ambiental',
    activate: 'Activar',
    desactivate: 'Desactivar',
    without_highlights: 'Sin marcadores para mostrar',
    comments: 'Comentarios',
    dictionary_msg_1: 'Ingresa la palabra que deseas buscar',
    dictionary_placeholder: 'Ejemplo: empatía',
    search_word: 'Buscar palabra',
    example: 'Ejemplo',
    notes_modal_msg: 'Escribe la nota que deseas crear',
    notes_modal_placeholder: 'Tipea tu nota aquí...',
    without_notes: 'Sin notas para mostrar',
    showAllNotes: 'Mostrar mis notas en el texto siempre.',
    reading_aloud: 'Narración',
    listen_read_aloud: 'Escuchar voz de narración',
    readaloud_msg_1: 'Puedes activar y desactivar el audio de narracion si lo deseas.',
    not_storyteller_data_found:
        'El narrador no está disponible para esta lectura, puedes intentar de nuevo más tarde.',
    choose_voice: 'Elige la voz que prefieras',
    my_notes: 'Mis notas',
    note_pill_msg: 'Nota creada',
    inactivity_modal: '¿Sigues leyendo? Hemos detectado que llevas 30 minutos sin cambiar de página.',
    reread_modal_msg: 'Este libro ya lo has leído por completo. ¿Quieres comenzar nuevamente?',
    without_beecoins: '¡Ups! No posees suficientes BeeCoins para usar el comodín 50/50. Responde correctamente preguntas de libros y desafíos para ganar recompensas. ',
    wildcard_alredy_use: 'Ya ha utilizado un comodín para esta pregunta',
    multiple_selection_only: 'Esta opción solo está disponible para preguntas de opción múltiple',
    no_meaning: 'No encontramos significado.',
    not_available: 'El diccionario no está disponible en este momento, puedes intentar de nuevo más tarde.',
    published: 'Publicado',
    finish_book_msg_1: '¡Has terminado tu lectura!',
    finish_book_msg_2: 'Te invitamos a la biblioteca a escoger tu siguiente libro.',
    saved_the: 'Guardada el',
    the_word: 'La palabra',
    congrats_questions: 'Has respondido todas las preguntas disponibles.',
    go_out: 'Salir',
    pause_read_aloud: 'Pausa la narración <br> para realizar cambios',
    no_audio_available: 'Audio no disponible para este libro',
}
